export default __webpack_public_path__ + "static/media/carousel-tp-marketplace.d81c3feb.jpg";